// header-drawer-fix.js
// Handles the background issue when mobile menu drawer is open with transparent header

document.addEventListener('DOMContentLoaded', function() {
  initHeaderBackgroundFix();
  
  // In case of dynamic section loads (Shopify)
  document.addEventListener('shopify:section:load', function() {
    initHeaderBackgroundFix();
  });
});

function initHeaderBackgroundFix() {
  // Get references to the drawer and header elements
  const menuDrawerDetails = document.querySelector('#Details-menu-drawer-container');
  const headerWrapper = document.querySelector('.header-wrapper');
  
  if (!menuDrawerDetails || !headerWrapper) return;
  
  // Get logo element if it exists
  const logoElement = headerWrapper.querySelector('.header__heading-logo');
  
  // Force apply classes on init if drawer is already open
  if (menuDrawerDetails.hasAttribute('open')) {
    headerWrapper.classList.add('drawer-open');
    if (logoElement && window.matchMedia('(max-width: 749px)').matches) {
      checkLogoBrightness(logoElement);
    }
  } else {
    headerWrapper.classList.remove('drawer-open');
  }
  
  // Create a mutation observer to watch for attribute changes on the details element
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.attributeName === 'open') {
        if (menuDrawerDetails.hasAttribute('open')) {
          // Menu drawer is open, add a class to header wrapper
          headerWrapper.classList.add('drawer-open');
          
          // Check if we should preserve the logo's original colors based on its brightness
          if (logoElement && window.matchMedia('(max-width: 749px)').matches) {
            checkLogoBrightness(logoElement);
          }
          
          // Ensure any inline styles for background are removed to let our CSS take over
          if (headerWrapper.hasAttribute('style')) {
            // Store original style in data attribute if not already stored
            if (!headerWrapper.hasAttribute('data-original-style')) {
              headerWrapper.setAttribute('data-original-style', headerWrapper.getAttribute('style'));
            }
            
            // Create a new style string without background properties
            const originalStyle = headerWrapper.getAttribute('style');
            const newStyle = originalStyle
              .replace(/background-image:[^;]+;?/g, '')
              .replace(/background-color:[^;]+;?/g, '')
              .replace(/background:[^;]+;?/g, '');
            
            headerWrapper.setAttribute('style', newStyle);
          }
        } else {
          // Menu drawer is closed, remove the class
          headerWrapper.classList.remove('drawer-open');
          
          // Restore original inline styles if they existed
          if (headerWrapper.hasAttribute('data-original-style')) {
            headerWrapper.setAttribute('style', headerWrapper.getAttribute('data-original-style'));
            headerWrapper.removeAttribute('data-original-style');
          }
          
          // Reset logo attributes
          if (logoElement) {
            logoElement.removeAttribute('data-preserve-logo-color');
          }
        }
      }
    });
  });
  
  // Start observing the details element for attribute changes
  observer.observe(menuDrawerDetails, { attributes: true });
}

// Function to check if a logo is light or dark and preserve original colors if needed
function checkLogoBrightness(logoElement) {
  // If logo is an SVG, we need to preserve its colors
  if (logoElement.tagName === 'svg' || 
      logoElement.querySelector('svg') || 
      (logoElement.src && logoElement.src.includes('.svg'))) {
    logoElement.setAttribute('data-preserve-logo-color', 'true');
    return;
  }
  
  // For PNG/JPG logos with transparency or light backgrounds, we should preserve colors
  // This is just a basic check - a full solution would need to analyze the image
  if (logoElement.src && (logoElement.src.includes('.png') || logoElement.currentSrc.includes('.png'))) {
    logoElement.setAttribute('data-preserve-logo-color', 'true');
  }
} 